import { createFileRoute, redirect } from '@tanstack/react-router';
import { fetchCurrentUser } from '@wundo/client/auth.ts';
import { DashboardPage } from '@/components/dashboard/DashboardPage.tsx';
import { canSeeDashboard } from '@/lib/canSeeDashboard.ts';

export const Route = createFileRoute('/_app/dashboard')({
  /* Without the rail item there is no page either: a link or a bookmark lands on the agenda. */
  beforeLoad: async ({ context }) => {
    const user = await context.queryClient.ensureQueryData({
      queryKey: ['currentUser'],
      queryFn: fetchCurrentUser,
    });

    if (!canSeeDashboard(user)) {
      throw redirect({ to: '/', replace: true });
    }
  },
  component: DashboardPage,
});
